import { useEffect, useState, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

const Streaming = (props) => {
  let socket = props.socket;
  const [conectados, setConectados] = useState([]);
  const videoRef = useRef(null | HTMLVideoElement);
  const streamRef = useRef(null | MediaStream);
  const [audioSource, setAudioSource] = useState("");
  const [videoSource, setVideoSource] = useState("");

  const [perfil, setPerfil] = useState({
    id: props.idUsuario.toString(),
    nbre: props.nbres,
    admon: props.tipoParticipante === 2 ? "1" : "0",
  });

  useEffect(() => {
    const prepareStream = async () => {
      const gotStream = async (stream) => {
        //const gotStream=async(stream: MediaStream)=>{
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      };

      const getStream = async () => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((track) => {
            track.stop();
          });
        }
        const contraints = {
          audio: {
            deviceId: audioSource !== "" ? { exact: audioSource } : undefined,
          },
          video: {
            deviceId: videoSource !== "" ? { exact: videoSource } : undefined,
          },
        };
        try {
          const stream = await navigator.mediaDevices.getUserMedia(contraints);
          gotStream(stream);
          socket.emit("stream", stream);
        } catch (error) {
          return error.message;
        }
      };
      await getStream();
    };

    if (props.tipoParticipante === 2) prepareStream();

    socket.emit("stream", perfil);

    socket.on("newUserStream", (datos) => {
      setConectados(datos);
    });

    return () => {
      //props.socket.off("message", mensaje)
    };
  }, []);

  return (
    <div className="container">
      <div className="row mb-5">
        {/* <select className="form-control" id="videoSource" name="videoSource" value={videoSource} ></select>
      <select className="form-control" id="audioSource" name="audioSource" value={audioSource} ></select> */}
        <video
          ref={videoRef}
          autoPlay //Inicia automaticamente
          muted //Para ingresar sin volumen
          playsInline
        ></video>
      </div>

      <div className="row mb-3">
        <Stack
          spacing={{ xs: 1, sm: 1 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          {conectados.toString().length > 0 &&
            conectados.map((reg, i) => {
              return (
                <div key={i}>
                  {/* {(i+1)%5 === 0 ? 'Multiplo': 'No es multiplo'} */}
                  {reg.id !== perfil.id && (
                    <Chip
                      key={i}
                      avatar={<Avatar>{reg.nbre.substring(0, 1)}</Avatar>}
                      label={reg.nbre}
                    />
                  )}
                </div>
              );
            })}
        </Stack>
      </div>
    </div>
  );
};

export default Streaming;
